import "./layers.css";
import { Moon, Sun } from "lucide-react";

import { captain } from "./captain/theme";
import { defineTheme, type ThemeDefinition } from "./types";

const light = defineTheme({ id: "light", label: "Light", icon: Sun, base: "light" });
const dark = defineTheme({ id: "dark", label: "Dark", icon: Moon, base: "dark" });

/** Every theme the theme picker offers, in menu order. Add a theme by adding its folder and listing it here. */
export const THEMES = [light, dark, captain] as const;

export type ThemeId = (typeof THEMES)[number]["id"];

export const DEFAULT_THEME_ID: ThemeId = "dark";

export const isThemeId = (value: string | null): value is ThemeId =>
  THEMES.some((theme) => theme.id === value);

export const getTheme = (id: ThemeId): ThemeDefinition =>
  THEMES.find((theme) => theme.id === id) ?? dark;

/** Light and dark themselves: no overrides on top of their index.css block. */
export const isBaseTheme = (theme: Pick<ThemeDefinition, "id" | "base">) => theme.id === theme.base;
